import { render, staticRenderFns } from "./ContactCampus.vue?vue&type=template&id=875aeb74&scoped=true&"
import script from "./ContactCampus.vue?vue&type=script&lang=js&"
export * from "./ContactCampus.vue?vue&type=script&lang=js&"
import style0 from "./ContactCampus.vue?vue&type=style&index=0&id=875aeb74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875aeb74",
  null
  
)

export default component.exports